module.exports = __webpack_public_path__ + "static/img/2.f7b28c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/hotKeywordsMap/map/2.png
// module id = sZtd
// module chunks = 2